module.exports = __webpack_public_path__ + "img/send.a956ab34.svg";